import { SET_CHECKOUT_NOTIFICATION, RESET_CHECKOUT_NOTIFICATION } from '../constants/ActionTypes'
import type GenericAction from './types/genericAction.types'

export type CheckoutNotificationAction = GenericAction<typeof SET_CHECKOUT_NOTIFICATION | typeof RESET_CHECKOUT_NOTIFICATION, { notification?: Notification }>

type Notification = {
    type: string
    message: string
    sticky: boolean
}

const checkoutNotification = (state: Notification | null = null, action: CheckoutNotificationAction) => {
    switch (action.type) {
        case SET_CHECKOUT_NOTIFICATION: {
            const { notification: { type, message, sticky } = {} } = action
            return { type, message, sticky }
        }

        case RESET_CHECKOUT_NOTIFICATION:
            return null

        default:
            return state
    }
}

export default checkoutNotification
